import React from "react";
import styled from "styled-components";

const PeriodSelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 15px 0 20px;
`;

const PeriodSelectorLabel = styled.div`
  font-size: 13px;
  color: #6b7280;
  font-family: "AllianceNo2-SemiBold", sans-serif;
`;

const PeriodItems = styled.div`
  display: flex;
  gap: 5px;
  position: relative;
  top: -3px;
`;

const PeriodItem = styled.div`
  border: 1px solid var(--text-primary, #000);
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 12px;
  font-family: "AllianceNo2-SemiBold", sans-serif;
  cursor: pointer;
  background-color: ${(props) =>
    props.$active ? "var(--text-primary, #000)" : "transparent"};
  color: ${(props) => (props.$active ? "#fff" : "var(--text-primary, #000)")};
  transition: all 0.3s;

  &:hover {
    background-color: var(--text-primary, #000);
    color: #fff;
  }
`;

export const periods = ["1d", "2d", "3d", "7d"];

const PeriodSelectorItem = ({ period, active, onClick }) => {
  return (
    <PeriodItem $active={active} onClick={onClick}>
      {period}
    </PeriodItem>
  );
};

function PeriodSelector({ period: activePeriod, setPeriod }) {
  return (
    <PeriodSelectorWrapper>
      <PeriodSelectorLabel>Last</PeriodSelectorLabel>
      <PeriodItems>
        {periods.map((period) => (
          <PeriodSelectorItem
            key={period}
            period={period}
            active={activePeriod === period}
            onClick={() => setPeriod(period)}
          />
        ))}
      </PeriodItems>
    </PeriodSelectorWrapper>
  );
}

export default PeriodSelector;
